import {  removeStudentTokenFromLocal } from "../../common";
import { studentTokenName } from "../../config";

// const getStudentFromLocalStorage = () => {
//   try {
//     const studentJSON = getStudentTokenFromLocal();
//     if (studentJSON) {
//       const student = JSON.parse(studentJSON);
//       if (student.authToken && student.loggedInTime) {
//         return student;
//       } else {
//         removeStudentTokenFromLocal();
//         return null;
//       }
//     }
//   } catch (e) {
//     removeStudentTokenFromLocal();
//     return null;
//   }
// };

const getStudentFromLocalStorage = () => {
  try {
    const student = JSON.parse(sessionStorage.getItem(studentTokenName));
    if (student && student.authToken && student.loggedInTime) {
      return student
    } else {
      removeStudentTokenFromLocal();
      return null
    }
  } catch (error) {
    removeStudentTokenFromLocal()
    return null
  }
}

const getInitial = () => {
  return getStudentFromLocalStorage();
};

const studentReducer = (state = getInitial(), action) => {
  switch (action.type) {
    case "LOGIN_STUDENT":
      const { loggedInTime, authToken } = action.payload;
      const newState = {
        loggedInTime: loggedInTime || Date.now(),
        authToken: authToken,
      };
      sessionStorage.setItem(studentTokenName, JSON.stringify(newState));
      return newState;
    case "LOGOUT_STUDENT":
      removeStudentTokenFromLocal();
      return null;
    default:
      return state;
  }
};

export default studentReducer;